import React, { useState, useEffect, useMemo } from 'react'
import useReduxState from 'src/hooks/useReduxState';
import { FilterSelection } from 'src/reusable/global';
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import produceClone from 'src/helper/produceClone';
import Dropdown from 'src/component/Global/Dropdown';
import { useOrderStore } from 'src/hooks/order';
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import AdminAccountFilterSelection from 'src/pages/Admin/AdminAccountFilterSelection';
import Helper from 'src/support/Helper';
import Constants from 'src/support/Constants';

const OrderHistorySearchFilter = (props) => {
    const [searchType, setSearchType] = useState('');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [searchError, setSearchError] = useState('');
    const [filterOrderStatus, setFilterOrderStatus] = useReduxState('', 'setFilterOrderStatus');
    const [{ filter_list }, { }, { set_filter_list }] = useAdminAccountFilterStore();

    const [{ order_manufacturer_list }, { fetch_manuFacturer_list }, { }] = useOrderStore();
    const [searchArrayData, setSearchArrayData] = useState([]);
    const [searchData, setSearchData] = useState({});
    const searchByDropdown = [
        { key: 'POlineItemNumber', slug: 'P.O. Line Item Number'},
        { key: 'PoNumber', slug: 'P.O. Number' },
        { key: 'OrderNumber', slug: 'Order Number' },
        { key: 'CustPartNumber', slug: 'Customer Part No.' },
        { key: 'MfrPartNumber', slug: 'Manufacturer Part No.' },
        { key: 'Manufacturer', slug: 'Manufacturer' },
        { key: 'OrderType', slug: 'Order Type' },
        { key: 'Buyer', slug: 'Buyer' }
    ]

    useEffect(() => {
        fetch_manuFacturer_list()
    }, [])

    const searchOptionModified = useMemo(() => {
        const modifiedOption = {};
        searchByDropdown.forEach(v => {
            modifiedOption[v.key] = v.slug;
        });
        return modifiedOption;
    })

    const orderStatusDropdown = [
        { key: 'Order_Placed', slug: 'Order Pending' },
        { key: 'In_process', slug: 'In Process' },
        { key: 'Canceled', slug: 'Cancelled' },
        { key: 'Shipped', slug: 'Shipped' },
        { key: 'Partially_Shipped', slug: 'Partially Shipped' },
        { key: 'Invoiced', slug: 'Invoiced' }
    ]

    const orderTypeList = [
        { key: 'Online', slug: 'Online' },
        { key: 'Offline', slug: 'Offline' }
    ]

    const setFilterOrder = async (data) => {
        await setFilterOrderStatus(data);
    };

    const setSearch = async (data) => {
        setSearchArrayData([])
        setSearchKeyword('');
        await setSearchType(data);
    };

    const setSearchKey = (data) => {
        if (searchType.toLocaleLowerCase() === 'manufacturer') {
            setSearchArrayData(data)
        } else {
            setSearchKeyword(data);
        }
    };

    const onSearch = () => {
        let search = {}
        if (searchType.toLocaleLowerCase() === 'manufacturer') {
            search = {
                ...searchData,
                [searchType]: searchArrayData
            };
        } else {
            search = {
                ...searchData,
                [searchType]: searchKeyword
            };
        }

        setSearchData(search)
        const keyToSearchType = {
            PoNumber: "P.O. Number",
            POlineItemNumber: "P.O. Line Item Number",
            OrderNumber: "Order Number",
            CustPartNumber: "Customer Part No.",
            MfrPartNumber: "Manufacturer Part No.",
            Manufacturer: "Manufacturer",
            OrderType: "Order Type",
            Buyer: "Buyer"
        };
        const filterList = Object.entries(search)
            .filter(([key, value]) => Helper.valueIsNotNull(value))
            .map(([key, value]) => {
                let val = {
                    searchType: keyToSearchType[key]
                };

                switch (key) {
                    case 'Manufacturer':
                        val['searchKeywordArr'] = value?.map((v) => ({ label: v.label, value: v.value }));
                        break;
                    default:
                        val['searchKeyword'] = value?.trim();
                        break;
                }
                return val;
            });

        const toCamelCase = (str) => {
            const stringWithoutLastDot = str && str.replace(/\.(?=[^.]*$)/, '');

            return stringWithoutLastDot
                ?.toLowerCase()
                ?.replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr?.toUpperCase())
                ?.replace(/\.(\w)/g, (_, chr) => chr.toUpperCase())
                ?.replace(/\b(\w)(\w*)/g, (_, first, rest) => first.toUpperCase() + rest);
        };

        const filterListObject = filterList?.reduce((acc, curr) => {
            const key = toCamelCase(curr?.searchType);

            if (key === "Manufacturer") {

                acc[key] = {
                    searchType: curr?.searchType,
                    searchKeywordArr: curr?.searchKeywordArr
                };
            } else {
                acc[key] = {
                    searchType: curr?.searchType,
                    searchKeyword: curr?.searchKeyword
                };
            }
            return acc;
        }, {});
        set_filter_list(filterListObject);
    };
    useEffect(() => {
        if (!filter_list || Object.keys(filter_list).length === 0) {
            setSearchKeyword('');
            setSearchType('');
            setSearchArrayData([]);
            setSearchData({})
        } else {
            const filter_option = {};
            Object.entries(filter_list).forEach(([key, value]) => {
                if (key === 'Manufacturer') {
                    filter_option['Manufacturer'] = value?.searchKeywordArr;
                } else {
                    filter_option[Constants.orderPayload[key]] = value.searchKeyword;
                }
            });
            setSearchData(filter_option);
        }
        setSearchArrayData(filter_list?.Manufacturer?.searchKeywordArr)
    }, [filter_list]);

    useEffect(() => {
        if (window.location.href.includes('orderNumber') && window.location.href.includes('POLineItemNumber')) {
            const searchParams = new URLSearchParams(window.location.search);
            let orderSearch = [{
                searchType: "OrderNumber",
                searchKeyword: searchParams.get('orderNumber')?.trim()
            },
                {
                    searchType: "PoLineItemNumber",
                    searchKeyword: searchParams.get('POLineItemNumber')?.trim()
                }
            ]

            const filterListObject = orderSearch?.reduce((acc, curr) => {
                let key = curr?.searchType
                acc[key] = {
                    searchType: curr?.searchType,
                    searchKeyword: curr?.searchKeyword
                };
                return acc;
            }, {});
            set_filter_list(filterListObject)

            function removeURLParameter(param) {
                const url = new URL(window.location.href);
                const searchParams = url.searchParams;

                if (searchParams.has(param)) {
                    searchParams.delete(param);
                }

                const newUrl = url.href;
                history.replaceState(null, '', newUrl);
            }
            removeURLParameter('orderNumber');
            removeURLParameter('POLineItemNumber');
        }
    }, [])
    return (
        <>
            <div className="d-flex align-items-center mb-2 flex-wrap see-orders m-b-10">
                <div className='m-b-15 m-r-30 '>
                    <label className="my-0 me-2" htmlFor="searchBy">Search by</label>
                    <Dropdown defaultText="All Orders"
                              class={'test'}
                              id="ddlSearchBy"
                              onDdlCallback={setSearch}
                              ddlList={searchByDropdown}
                              label={"slug"}
                              value={"key"}
                              selectedValue={searchType}
                    />
                </div>
                {(searchType !== '' && searchType.toLocaleLowerCase() !== 'manufacturer' && searchType.toLocaleLowerCase() !== 'ordertype') &&
                    <div className="m-b-15 m-r-30 align-self-end">
                        <input type="text" className='form-control form-control-sm' placeholder={searchOptionModified[searchType]} name={searchType} value={searchKeyword}
                               onChange={({ target: { value } }) => setSearchKey(value)}
                        />
                        {searchError.trim().length > 0 && <p className='error'>searchError</p>}
                    </div>
                }

                {(searchType !== '' && searchType.toLocaleLowerCase() === 'manufacturer') &&

                    <div className="m-b-15 m-r-30 align-self-end multiselect w180 z-index9">
                        <ReactMultiSelectCheckboxes
                            placeholderButtonLabel={ 'Select ' + searchOptionModified[searchType]}
                            style={{ minWidth: "300px" }}
                            value={searchArrayData || []}
                            options={
                                (order_manufacturer_list?.length &&
                                    order_manufacturer_list?.map((option) => ({
                                        value: option?.manufacturerCode,
                                        label: option?.manufacturerName
                                    }))) || []
                            }
                            onChange={(selectedOptions) => { setSearchKey(selectedOptions) }}
                        />
                    </div>
                }

                {searchType !== '' && searchType.toLocaleLowerCase() === 'ordertype' &&
                    <div className="m-b-15 m-r-30 align-self-end selectbox w175">
                        <Dropdown defaultText="Select Order Type"
                                  class={'test'}
                                  id="ddlOrderType"
                                  onDdlCallback={setSearchKey}
                                  ddlList={orderTypeList}
                                  label={"slug"}
                                  value={"key"}
                                  selectedValue={searchKeyword}
                        />
                    </div>
                }

                <div className='m-b-15 m-r-30 '>
                    <div className="dropdown">
                        <label className="my-0 me-2" htmlFor="OrderStatus">Order Item Status</label>
                        <div className="selectbox w175">
                            <Dropdown defaultText="All Orders"
                                      class={'test'}
                                      id="OrderStatus"
                                      onDdlCallback={setFilterOrder}
                                      ddlList={orderStatusDropdown}
                                      value={"key"}
                                      label={"slug"}
                                      selectedValue={filterOrderStatus}
                            />
                        </div>
                    </div>
                </div>
                <div className='m-b-15  align-self-end'>
                    <button className={'bs5 btn btn-secondary w105 ' + ((searchType.length > 0 && searchKeyword && searchKeyword.length >= 2) || searchArrayData?.length > 0 ? "" : "disabled")}
                            onClick={() => onSearch()}
                            disabled={(searchType.length > 0 && searchKeyword && searchKeyword.length >= 2) || searchArrayData?.length > 0 ? false : true}>
                        Search
                    </button>
                </div>
            </div>

            <AdminAccountFilterSelection />
        </>
    )
}

export default OrderHistorySearchFilter